export default require('./TimerCurrent').default
